// Installable app: register the service worker (offline play, instant start)
// and offer "Install the app" where the browser supports the prompt.

import { track } from '@/meta/analytics';

interface InstallPrompt extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

export function setupPwa(): void {
  const testing = new URLSearchParams(location.search).get('test') === '1';
  // Never under E2E: a cached worker would serve stale builds between runs
  if (import.meta.env.PROD && !testing && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => undefined);
    });
  }

  const btn = document.getElementById('install-btn');
  let deferred: InstallPrompt | null = null;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferred = e as InstallPrompt;
    if (btn) btn.hidden = false;
  });
  btn?.addEventListener('click', () => {
    const prompt = deferred;
    if (!prompt) return;
    deferred = null;
    btn.hidden = true;
    void prompt.prompt();
    void prompt.userChoice.then((c) => track('PWA', 'InstallPrompt', c.outcome));
  });
  window.addEventListener('appinstalled', () => track('PWA', 'Installed'));
  if (new URLSearchParams(location.search).get('source') === 'pwa')
    track('PWA', 'LaunchedInstalled');
}
